import { useState, useMemo, useEffect } from 'react';
import { useTypedQuery } from 'src/utils/hooks/useTypedQuery';
import { RateCardQuery } from './utils/RateCards.types';
import { GetRateCardsDocument, RateCardDataFragment } from './utils/__generated__/GetRateCards.graphql';
import { filterNotEmpty } from '@beeline.com/bp-design-system';

export const useGetRateCardData = () => {
  const [variables, setVariables] = useState<RateCardQuery>();
  const { data, loading, get: getRateCards, refetch } = useTypedQuery(GetRateCardsDocument);

  const rateCards: RateCardDataFragment[] = useMemo(
    () => filterNotEmpty(data?.rateCards?.items) ?? [],
    [data?.rateCards?.items]
  );
  const totalCount = data?.rateCards?.totalCount ?? 0;

  useEffect(() => {
    if (variables?.page?.limit) {
      getRateCards({ variables: { ...variables, query: { ...variables.query } } });
    }
  }, [variables, getRateCards]);

  return {
    rateCards,
    totalCount,
    loading,
    variables,
    setVariables,
    refetch
  };
};
